'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PageConstants = require('./PageConstants');

var _UIAbstractPageTemplate = require('./UIAbstractPageTemplate');

var _UIAbstractPageTemplate2 = _interopRequireDefault(_UIAbstractPageTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIDashboardPage(_ref) {
  var alertComponent = _ref.alertComponent,
      children = _ref.children,
      headerComponent = _ref.headerComponent,
      moveSidebarToBottom = _ref.moveSidebarToBottom,
      pageLayout = _ref.pageLayout,
      sidebarComponent = _ref.sidebarComponent,
      tabs = _ref.tabs,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ['alertComponent', 'children', 'headerComponent', 'moveSidebarToBottom', 'pageLayout', 'sidebarComponent', 'tabs', 'title']);

  return _react2.default.createElement(
    _UIAbstractPageTemplate2.default,
    _extends({}, rest, {
      alertComponent: alertComponent,
      headerComponent: headerComponent,
      horizontalDivider: true,
      mainSectionBackgroundColor: _PageConstants.CARD_BACKGROUND,
      moveSidebarToBottom: moveSidebarToBottom,
      pageLayout: pageLayout,
      sidebarComponent: sidebarComponent,
      tabs: tabs,
      title: title
    }),
    children
  );
}

var _UIAbstractPageTempla = _UIAbstractPageTemplate2.default.propTypes,
    alertComponent = _UIAbstractPageTempla.alertComponent,
    children = _UIAbstractPageTempla.children,
    headerComponent = _UIAbstractPageTempla.headerComponent,
    moveSidebarToBottom = _UIAbstractPageTempla.moveSidebarToBottom,
    pageLayout = _UIAbstractPageTempla.pageLayout,
    sidebarComponent = _UIAbstractPageTempla.sidebarComponent,
    tabs = _UIAbstractPageTempla.tabs,
    title = _UIAbstractPageTempla.title;


UIDashboardPage.propTypes = {
  alertComponent: alertComponent,
  children: children,
  headerComponent: headerComponent,
  moveSidebarToBottom: moveSidebarToBottom,
  pageLayout: pageLayout,
  sidebarComponent: sidebarComponent,
  tabs: tabs,
  title: title
};

exports.default = UIDashboardPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/page/UIDashboardPage.js
// module id = 363
// module chunks = 0